// The ONE square button of a home widget header (HOME_WIDGETS_SPEC.md §2 +
// §6): 32 × 32 (1:1 — Nika: "all icon buttons should have 1/1 aspect ratio"),
// `layer` fill, hover `selected`, glyph `iconSm`, an aria-label that is its
// verb. It is the widget's primary verb (＋ Add / New) or ↗ Open — decision
// H3 A. The card around it is itself the open link; the card's click handler
// skips buttons, so this control never also opens the widget.
//
//   HomeWidgetAction: { Icon: { name: 'plus' }, 'aria-label': …, onClick: … }
//
// The house IconButton (SquareButton) keeps it square; the global focus ring
// is the reset's.
export const HomeWidgetAction = {
  extends: 'IconButton',
  class: 'gs-no-drag widget-header-action',
  boxSize: 'iconXl',
  minWidth: 'iconXl',
  minHeight: 'iconXl',
  padding: '0',
  flexShrink: '0',
  round: 'radiusControl',
  theme: 'layer',
  color: 'title',
  border: 'none',
  cursor: 'pointer',
  align: 'center center',
  ':hover': { background: 'selected' },
  ':active': { background: 'selected' },
  Icon: { boxSize: 'iconSm' }
}
